<table class="ir-plugin-table" *ngFor="let item of observationsAndRecommendations">
  <tbody *ngIf="item.Selected">
    <tr class="th-plugin-line--header">
      <td colspan="5">
        <span
          >{{ 'plugins.installationobservation.name' | translate }} :
          <strong innerHtml="{{ item.Observation }}"></strong
        ></span>
      </td>
    </tr>
    <tr>
      <td colspan="5">
        <span
          >{{ 'plugins.installationobservation.recommendation' | translate }} :
          <strong innerHtml="{{ item.Recommendation }}"></strong
        ></span>
      </td>
    </tr>

    <ng-container *ngFor="let i of item.impacts | keyvalue">
      <tr class="th-plugin-line--content" *ngIf="i.value.enabled">
        <td>
          <span
            >{{ 'plugins.installationobservation.impact' | translate }} :
            <strong class="important">{{
              'plugins.installationobservation.value.' + i.value.id + '.title' | translate : { default: i.value.name }
            }}</strong></span
          >
        </td>
        <td class="th-plugin-line--value">
          <span
            ><strong class="important">{{ i.value.text }}</strong>
            {{
              'plugins.installationobservation.value.' + i.value.id + '.boost'
                | translate : { default: i.value.name + ' boost' }
            }}</span
          >
        </td>
      </tr>
    </ng-container>

    <tr *ngIf="item.Responsible != null">
      <td>
        <span
          >{{ 'plugins.installationobservation.to-take-action' | translate }} :
          <strong>{{ item.Responsible | responsiblespipe }}</strong></span
        >
      </td>
    </tr>
    <tr *ngIf="item.Machines && item.Machines.length > 0">
      <td>
        <span
          >{{ 'plugins.installationobservation.machines' | translate }} :
          <strong *ngFor="let m of item.Machines; let isLast = last"
            >{{ m.SerialNumber ? m.ModelId + ' (' + m.SerialNumber + ')' : m.ModelId }}{{ isLast ? '' : ', ' }}</strong
          ></span
        >
      </td>
    </tr>
    <tr *ngIf="item.Priority != null">
      <td>
        <span
          >{{ 'plugins.installationobservation.priority' | translate }} :
          <strong>{{ item.Priority | prioritiespipe }}</strong></span
        >
      </td>
    </tr>
    <tr *ngIf="item.Parts && item.Parts.length">
      <td>
        <span>{{ 'plugins.parts.parts-management' | translate }} :</span>
      </td>
    </tr>

    <tr *ngFor="let part of item.Parts">
      <td>
        <div class="ir-plugin-values th-plugin-values">
          <p>
            <span>{{ part?.Id }}-</span><span>{{ part?.Page }}-</span><span>{{ part?.Position }}-</span
            ><span>{{ part?.PartsName }}</span
            ><span *ngIf="part?.Quantity"
              ><strong> x {{ part?.Quantity }}</strong></span
            >
          </p>
        </div>
      </td>
    </tr>
  </tbody>
</table>
